import React, { type FunctionComponent } from 'react'
import { getAuth0ApplicationConfiguration, type Auth0ApplicationConfiguration } from '@borg/aemp-integrations'
import { Auth0Provider } from '@equipmentshare/auth0-react'
import { AppLoader } from './app-loader'
import { App } from './app'

export const AuthWrapper: FunctionComponent = () => {
	const { audience, clientId, domain, redirectUri }: Auth0ApplicationConfiguration = getAuth0ApplicationConfiguration()

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			audience={audience}
			redirectUri={redirectUri}
			withAuthenticationRequiredOptions={{
				onRedirecting: () => ( <AppLoader /> ),
			}}
		>
			<App />
		</Auth0Provider>
	)
}
